<template>
  <tr class="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-200">
    <!-- Sipariş -->
    <td class="px-3 py-3 border-b border-gray-200 dark:border-gray-700">
      <div class="flex items-center">
        <div class="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
        <div>
          <div class="text-sm font-medium text-gray-900 dark:text-gray-100">{{ order.orderNo }}</div>
          <div class="text-xs text-gray-500 dark:text-gray-400">{{ order.name }}</div>
        </div>
      </div>
    </td>
    
    <!-- Müşteri -->
    <td class="px-3 py-3 border-b border-gray-200 dark:border-gray-700">
      <span class="text-sm text-gray-900 dark:text-gray-100">{{ order.customer }}</span>
    </td>
    
    <!-- Miktar -->
    <td class="px-3 py-3 border-b border-gray-200 dark:border-gray-700">
      <div class="flex items-center">
        <i class="fas fa-weight text-gray-400 mr-1"></i>
        <span class="text-sm font-medium text-gray-900 dark:text-gray-100">{{ order.amount }}</span>
        <span class="text-xs text-gray-500 ml-1">ton</span>
      </div>
    </td>
    
    <!-- Rota -->
    <td class="px-3 py-3 border-b border-gray-200 dark:border-gray-700">
      <div class="space-y-1">
        <div class="text-xs text-gray-600 dark:text-gray-400">
          <i class="fas fa-arrow-up text-green-500 mr-1"></i>
          {{ order.outpointAdress }}
        </div>
        <div class="text-xs text-gray-600 dark:text-gray-400">
          <i class="fas fa-arrow-down text-red-500 mr-1"></i>
          {{ order.targetAdress }}
        </div>
      </div>
    </td>
    <td class="px-3 py-3 border-b border-gray-200 dark:border-gray-700">
      <div class="w-40">
        <diffInput
          type="select"
          :hideContainer="true"
          :optList="[
            {
              id: 3,
              name: 'Hepsi',
            },
            {
              id: 1,
              name: 'Kiralık',
            },
            {
              id: 2,
              name: 'Özmal',
            },
          ]"
          minlength="1"
          :required="true"
          v-model="order.haveType"
        />
      </div>
    </td>
    <!-- Araç -->
    <td class="px-3 py-3 border-b border-gray-200 dark:border-gray-700">
      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200">
        <i class="fas fa-truck mr-1"></i>
        {{ order.recomendedCount || 1 }}
      </span>
    </td>
    
    <!-- Tür -->
    <td class="px-3 py-3 border-b border-gray-200 dark:border-gray-700">
      <span class="text-xs text-gray-500 dark:text-gray-400">{{ order.productType }}</span>
    </td>
    
    <!-- Mesafe -->
    <td class="px-3 py-3 border-b border-gray-200 dark:border-gray-700">
      <div class="flex items-center text-sm text-gray-600 dark:text-gray-400">
        <i class="fas fa-route text-blue-500 mr-1"></i>
        <span>--</span>
      </div>
    </td>
    
    <!-- Tarih -->
    <td class="px-3 py-3 border-b border-gray-200 dark:border-gray-700">
      <div class="text-sm text-gray-900 dark:text-gray-100">
        <i class="fas fa-calendar text-gray-400 mr-1"></i>
        {{ formatDate(order.deliveryDate) }}
      </div>
    </td>
    
    <!-- İşlemler -->
    <td class="px-3 py-3 border-b border-gray-200 dark:border-gray-700">
      <button
        type="button"
        @click="$emit('delete', order)"
        class="w-8 h-8 bg-red-500 hover:bg-red-600 text-white rounded-md transition-colors duration-200 flex items-center justify-center"
        title="Siparişi Sil"
      >
        <i class="fas fa-trash text-xs"></i>
      </button>
    </td>
  </tr>
</template>

<script>
import diffInput from "@/components/general/diffInput.vue";
export default {
  name: "OrderRow",
  props: {
    order: {
      type: Object,
      required: true
    }
  }, components: {
    diffInput,
  },
  methods: {
    formatDate(date) {
      if (!date) return '--';
      return new Date(date).toLocaleDateString('tr-TR');
    }
  }
};
</script>